<template>
  <transition name="node-context-menu">
    <div v-if="visible"
         class="node-context-menu"
         :data-id="id"
         :style="{ left: (left * reversedPaneScale) + 'px', top: (top * reversedPaneScale) + 'px', transform: `scale(${reversedPaneScale}) translateZ(0)` }">
      <button type="button"
              @click="onHighlightToggleClick">
        <i class="icon icon--highlight" />
        {{ $t('trend.nodeContextMenu.'+ (isSameNodeHighlighted ? 'cancelFocus' : 'focusSession')) }}
      </button>
      <button type="button"
              @click="onNodeReportClick">
        <i class="icon icon--node-report" />
        {{ $t('trend.nodeContextMenu.nodeReport') }}
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BaNodeContextMenu',
  props: {
    left: {
      type: Number,
      required: true
    },
    top: {
      type: Number,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    paneScale: {
      type: Number,
      required: true
    },
    focusedSequenceIndex: {
      type: Number,
      required: true
    },
    focusedNodeIndex: {
      type: Number,
      required: true
    },
    highlightedSequenceIndex: {
      type: Number,
      required: true
    },
    highlightedNodeIndex: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
    }
  },
  watch: {
    visible (value) {
      if (value) {
        requestAnimationFrame(() => {
          this.$el.style.marginLeft = this.$el.style.marginTop = ''
          const rect = this.$el.getBoundingClientRect()
          this.$el.style.marginLeft = rect.right > window.innerWidth ? -(rect.width + 10) * this.reversedPaneScale + 'px' : ''
          this.$el.style.marginTop = rect.bottom > window.innerHeight ? -(rect.height + 10) * this.reversedPaneScale + 'px' : ''
        })
      }
    }
  },
  computed: {
    id () {
      return this.focusedSequenceIndex + '-' + this.focusedNodeIndex
    },
    isSameNodeHighlighted () {
      return this.highlightedSequenceIndex === this.focusedSequenceIndex && this.highlightedNodeIndex === this.focusedNodeIndex
    },
    reversedPaneScale () {
      return 1 / this.paneScale
    }
  },
  mounted () {
    document.body.addEventListener('pointerdown', this.checkCloseLayer)
  },
  beforeDestroy () {
    document.body.removeEventListener('pointerdown', this.checkCloseLayer)
  },
  methods: {
    onHighlightToggleClick (e) {
      if (this.isSameNodeHighlighted) {
        this.$emit('onRemoveHighlightClick')
      } else {
        this.$emit('onHighlightNodeClick')
      }
    },
    onNodeReportClick (e) {
      this.$emit('onNodeReportClick')
    },
    checkCloseLayer (e) {
      if (this.visible) {
        const body = document.body
        let target = e.target
        while (target !== body) {
          if (target.dataset.id === this.id || target.id === this.id) {
            return
          }
          target = target.parentNode
        }
        this.$emit('onCloseContextMenu')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.node-context-menu {
  position: absolute;
  left: 0;
  top: 0;
  margin: 10px 0 0 10px;
  padding: 5px 0;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 12px 15px -6px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(0, 0, 0, 0.25);
  transform-origin: 0 0;
  z-index: 6;

  &-enter-active, &-leave-active {
    transition: opacity 0.1s, transform 0.1s $ease-out-quart;
  }
  &-enter, &-leave-to {
    opacity: 0;
    transform: translate3d(0, 3px, 0);
  }

  button {
    position: relative;
    width: 100%;
    height: 30px;
    font-size: 12px;
    color: #2f2f2f;
    text-align: left;
    line-height: 30px;
    padding: 0 19px 0 34px;
    box-sizing: border-box;
    display: block;
    transition: background-color 0.2s;

    &:hover {
      background-color: #ebebeb;
    }

    .icon {
      position: absolute;
      left: 10px;
      top: 7px;
    }
  }
}
</style>
